<template>
  <div id="app">
    <ThePageHeader></ThePageHeader>
    <PMFPlot></PMFPlot>
    <SimulationsList></SimulationsList>
    <TheEditSimulationModal></TheEditSimulationModal>
    <ThePageFooter></ThePageFooter>
  </div>
</template>

<script>
import ThePageHeader from "./components/ThePageHeader";
import ThePageFooter from "./components/ThePageFooter";
import SimulationsList from "./components/simulationsDisplay/SimulationsList";
import TheEditSimulationModal from "./components/simulationEdit/TheEditSimulationModal";
import PMFPlot from "./components/simulationStatsDisplay/PMFPlot";
export default {
  name: "App",
  components: {
    PMFPlot,
    TheEditSimulationModal,
    SimulationsList,
    ThePageFooter,
    ThePageHeader
  }
};
</script>
